import React, { useState } from "react";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
  Textarea,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";
import { handleSendNotification } from "actions/actions";
import { toast } from "react-toastify";
const SendNotification = ({ selectedIds, userRole }) => {
  const [formData, setFormData] = useState({
    title: "",
    body: "",
  });

  const handleSend = async (type) => {
    let body = {};
    if (type === "all") {
      body = {
        title: formData.title,
        body: formData.body,
        userRole,
      };
    } else {
      body = {
        title: formData.title,
        body: formData.body,
        userIds: selectedIds,
      };
    }

    if (!body.title || !body.body) {
      return toast.error("الرجاء ملء جميع الحقول");
    } else if (selectedIds.length === 0 && type !== "all") {
      return toast.error("الرجاء تحديد مستخدم واحد على الأقل");
    }

    const res = await handleSendNotification(body);

    if (res.error) {
      return toast.error(res.error);
    }

    toast.success(res.success);
    setFormData({ title: "", body: "" });
  };

  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        <button
          className="my-4 rounded-md bg-blueSecondary py-2 px-4 text-white transition-all float-end hover:bg-brandLinear"
          variant="outline"
          size="sm"
        >
          إرسال إشعار
        </button>
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">إرسال اشعار</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="mb-4">
            <label className="mb-2 block text-base" htmlFor="title">
              العنوان
            </label>

            <Input
              className="w-full border p-2"
              placeholder="الرجاء كتابة العنوان"
              id="title"
              value={formData.title}
              onChange={(e) =>
                setFormData({ ...formData, title: e.target.value })
              }
            />
          </div>
          <div className="mb-4">
            <label className="mb-2 block text-base" htmlFor="body">
              الرسالة
            </label>

            <Textarea
              className="h-32 w-full resize-none border p-2"
              placeholder="الرجاء كتابة الرسالة"
              id="body"
              value={formData.body}
              onChange={(e) =>
                setFormData({ ...formData, body: e.target.value })
              }
            />
          </div>
        </DialogBody>
        <DialogFooter>
          <Button onClick={() => handleSend("selected")} variant="outline">
            <span>إرسال</span>
          </Button>
          <Button onClick={() => handleSend("all")} variant="outline">
            <span>إرسال للجميع</span>
          </Button>

          <DialogActionTrigger asChild>
            <Button variant="outline">
              <span>إلغاء</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default SendNotification;
